import { reducerWithInitialState } from 'typescript-fsa-reducers';

export interface TableRowTitleProps {
  header: string[];
  data: { [key: string]: string[] };
}

export interface ReportTableRowState {
  tableRowTitle: TableRowTitleProps;
  displayKeyList: string[];
}

export const getReportTableRowKeys = () => {
  return reportTableRowInitialState.displayKeyList;
};

const reportTableRowInitialState: ReportTableRowState = {
  tableRowTitle: {
    header: ['商材カテゴリ', '契約形態'],

    // テーブルデータの一部。残りはバックエンドから来ます。
    data: {
      total: ['', ''],
      customers: ['', ''],
      smartphoneNew: ['HSスマホ', '純新規'],
      smartphoneTransfer: ['HSスマホ', '番号移行'],
      smartphoneChange: ['HSスマホ', '機変'],
      smartphoneMnp: ['HSスマホ', '乗換（転入）'],
      smartphoneContrChg: ['HSスマホ', '契約変更'],
      simNew: ['SIM単体', '純新規'],
      simTransfer: ['SIM単体', '番号移行'],
      simChange: ['SIM単体', '機変'],
      simMnp: ['SIM単体', '乗換（転入）'],
      simContrChg: ['SIM単体', '契約変更'],
      garakeiNew: ['HSスマホ以外', '純新規'],
      garakeiTransfer: ['HSスマホ以外', '番号移行'],
      garakeiChange: ['HSスマホ以外', '機変'],
      garakeiMnp: ['HSスマホ以外', '乗換（転入）'],
      garakeiContrChg: ['HSスマホ以外', '契約変更'],
      tabletNew: ['タブレット', '純新規'],
      tabletChange: ['タブレット', '機変'],
      otherNew: ['その他（モバイル）', '純新規'],
      otherTransfer: ['その他（モバイル）', '番号移行'],
      otherChange: ['その他（モバイル）', '機変'],
      otherMnp: ['その他（モバイル）', '乗換（転入）'],
      otherContrChg: ['その他（モバイル）', '契約変更'],
      hikariNew: ['ソフトバンク光', '純新規'],
      hikariDiverted: ['ソフトバンク光', '転用'],
      hikariChange: ['ソフトバンク光', '事業者変更'],
      hikariReuse: ['ソフトバンク光', '光回線再利用'],
      auroraNew: ['SoftBank 光＋', '新規'],
      auroraSrvChgHikari: ['SoftBank 光＋', 'サービス変更（SB 光）'],
      auroraSrvChgAir: ['SoftBank 光＋', 'サービス変更（SB Air）'],
      auroraReUseHikari: ['SoftBank 光＋', '光回線再利用（コラボ光）'],
      auroraSrvChgBbisp: ['SoftBank 光＋', 'サービス変更（BBISP）'],
      airNew: ['ソフトバンクAir', '純新規'],
      airChange: ['ソフトバンクAir', '機変'],
      denwaNew: ['おうちのでんわ', '純新規'],
      denkiNew: ['おうちでんき', '純新規'],
      dataBoxNew: ['あんしんデータボックス', '新規'],
      basketLiveNew: ['バスケットLIVE', '新規'],
      smartphoneSetSupportNew: ['店頭スマホサポート（他社）', '新規（定額加入／サポート利用）'],
    },
  },

  // テーブルデータにアクセスし表示するためのキー。
  // データはフロントとバックエンドの両方に分かれている。
  // このキーは両方のデータにアクセスするために使われる。
  // 注意点
  // - データの表示順はこのキーの順番になる
  // - バックエンドから返るJSONのキーと一致しないと、データアクセスに失敗するので注意
  // - フロントエンドのtableRowTitle#dataとも一致させる。理由は上記と同じ。
  // - レポート画面の商材別集計テーブルで、行の表示順とキー参照に使う。
  // - 同テーブルの表示対象外のキーは入れずに、表示要件が確定したら追加する。
  // - [PCM-P-0456-0.SB光＋からのサ変追加]で追加された項目は表示要件に含まれないため、hikariSrvChgAir/hikariSrvChgBbisp/hikariSrvChgAurora/airSrvChgHikari/airSrvChgAurora は追加しない。
  displayKeyList: [
    'total',
    'customers',
    'smartphoneNew',
    'smartphoneTransfer',
    'smartphoneChange',
    'smartphoneMnp',
    'smartphoneContrChg',
    'simNew',
    'simTransfer',
    'simChange',
    'simMnp',
    'simContrChg',
    'garakeiNew',
    'garakeiTransfer',
    'garakeiChange',
    'garakeiMnp',
    'garakeiContrChg',
    'tabletNew',
    'tabletChange',
    'otherNew',
    'otherTransfer',
    'otherChange',
    'otherMnp',
    'otherContrChg',
    'hikariNew',
    'hikariDiverted',
    'hikariChange',
    'hikariReuse',
    'auroraNew',
    'auroraSrvChgHikari',
    'auroraSrvChgAir',
    'auroraReUseHikari',
    'auroraSrvChgBbisp',
    'airNew',
    'airChange',
    'denwaNew',
    'denkiNew',
    'dataBoxNew',
    'basketLiveNew',
    'smartphoneSetSupportNew',
  ],
};

export const ReportTableRowReducer = reducerWithInitialState(reportTableRowInitialState);
